import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CommonSuccesModalPage } from './common-succes-modal.page';

const routes: Routes = [
  {
    path: '',
    component: CommonSuccesModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CommonSuccesModalPageRoutingModule {}
